export interface MangaItem {
  id: number;
  title: string;
  altTitle: string;
  cover: string;
  category: string;
  status: '连载中' | '已完结';
  episodes: number;
  views: string;
  rating: string;
  latest: string;
  updateTime: string;
  desc: string;
  exclusive?: boolean;
  preview?: boolean;
  uncensored?: boolean;
}

export interface CategoryItem {
  name: string;
  icon: string;
  count: string;
  desc: string;
}

export const categories: CategoryItem[] = [
  { name: '热血战斗', icon: 'ri-fire-fill', count: '860+', desc: '燃到炸裂的动作名场面' },
  { name: '奇幻异界', icon: 'ri-sparkling-2-fill', count: '720+', desc: '魔法与异世界的冒险' },
  { name: '悬疑推理', icon: 'ri-eye-2-fill', count: '540+', desc: '烧脑反转一追到底' },
  { name: '恋爱日常', icon: 'ri-heart-3-fill', count: '680+', desc: '甜度爆表的青春物语' },
  { name: '轻松搞笑', icon: 'ri-emotion-laugh-fill', count: '460+', desc: '解压神器笑到停不下来' },
  { name: '科幻星际', icon: 'ri-rocket-2-fill', count: '390+', desc: '未来世界与机械浪漫' },
  { name: '冒险热血', icon: 'ri-compass-3-fill', count: '510+', desc: '踏上未知的征途' },
  { name: '校园青春', icon: 'ri-graduation-cap-fill', count: '430+', desc: '属于你的校园回忆' },
];

export const featured: MangaItem[] = [
  {
    id: 1,
    title: '燃魂少年',
    altTitle: 'Burning Soul Boy',
    cover: 'https://readdy.ai/api/search-image?query=Dynamic%20anime%20manga%20cover%20illustration%20of%20a%20determined%20young%20hero%20wielding%20flames%20in%20a%20battle%20pose%2C%20vibrant%20coral%20orange%20and%20amber%20color%20palette%2C%20bold%20linework%2C%20dramatic%20energy%20sparks%2C%20stylized%20cel%20shading%2C%20clean%20cream%20background%20with%20action%20speed%20lines%2C%20high%20detail%20illustration%20artwork&width=600&height=800&seq=manga-cover-01&orientation=portrait',
    category: '热血战斗',
    status: '连载中',
    episodes: 328,
    views: '1286万',
    rating: '9.6',
    latest: '第 328 话',
    updateTime: '今日更新',
    desc: '被火焰选中的少年踏上武道之巅，一路热血开挂，燃点密集到每一话都想拍桌。',
    exclusive: true,
    uncensored: true,
  },
  {
    id: 2,
    title: '斗破九霄',
    altTitle: 'Break the Nine Skies',
    cover: 'https://readdy.ai/api/search-image?query=Epic%20anime%20manga%20cover%20of%20a%20sword%20master%20ascending%20through%20storm%20clouds%2C%20gold%20and%20amber%20energy%20glow%2C%20warm%20dramatic%20lighting%2C%20detailed%20armor%20and%20sword%2C%20stylized%20chinese%20fantasy%20martial%20arts%20illustration%2C%20cinematic%20composition%2C%20cream%20sky%20background%2C%20rich%20detail%20artwork&width=600&height=800&seq=manga-cover-02&orientation=portrait',
    category: '奇幻异界',
    status: '连载中',
    episodes: 412,
    views: '2013万',
    rating: '9.4',
    latest: '第 412 话',
    updateTime: '今日更新',
    desc: '废柴少年逆天改命，登顶九霄的故事，世界观宏大，每一话都是视觉盛宴。',
    preview: true,
    uncensored: true,
  },
  {
    id: 3,
    title: '幻影行者',
    altTitle: 'Phantom Walker',
    cover: 'https://readdy.ai/api/search-image?query=Mysterious%20anime%20manga%20cover%20of%20a%20hooded%20rogue%20with%20glowing%20amber%20eyes%20vanishing%20into%20shadows%2C%20teal%20and%20gold%20accent%20light%2C%20moody%20warm%20tones%2C%20stylized%20fantasy%20ninja%20illustration%2C%20dark%20elegant%20composition%2C%20cream%20gradient%20backdrop%2C%20detailed%20linework%20artwork&width=600&height=800&seq=manga-cover-03&orientation=portrait',
    category: '悬疑推理',
    status: '连载中',
    episodes: 196,
    views: '786万',
    rating: '9.3',
    latest: '第 196 话',
    updateTime: '昨日更新',
    desc: '能在阴影与光影之间穿梭的神秘行者，卷入一场关乎世界命运的阴谋。',
    exclusive: true,
    uncensored: true,
  },
  {
    id: 4,
    title: '同桌的向日葵',
    altTitle: 'Sunflower Deskmate',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20romantic%20anime%20manga%20cover%20of%20a%20smiling%20schoolgirl%20holding%20sunflowers%2C%20soft%20coral%20and%20cream%20palette%2C%20gentle%20sunlight%2C%20sweet%20youth%20romance%20illustration%2C%20cute%20shojo%20style%2C%20clean%20warm%20background%2C%20delicate%20detail%20artwork&width=600&height=800&seq=manga-cover-04&orientation=portrait',
    category: '恋爱日常',
    status: '连载中',
    episodes: 154,
    views: '642万',
    rating: '9.5',
    latest: '第 154 话',
    updateTime: '今日更新',
    desc: '向日葵般的女孩闯进平淡日常，甜甜的校园恋爱看得人嘴角疯狂上扬。',
    preview: true,
  },
  {
    id: 5,
    title: '爆笑食堂',
    altTitle: 'Comedy Canteen',
    cover: 'https://readdy.ai/api/search-image?query=Funny%20anime%20manga%20cover%20of%20a%20cheerful%20chef%20character%20with%20steaming%20food%20and%20comical%20expressions%2C%20bright%20warm%20amber%20and%20coral%20colors%2C%20playful%20chibi%20style%2C%20lively%20comedy%20illustration%2C%20clean%20cream%20background%2C%20bold%20cartoon%20linework%20artwork&width=600&height=800&seq=manga-cover-05&orientation=portrait',
    category: '轻松搞笑',
    status: '连载中',
    episodes: 87,
    views: '358万',
    rating: '9.1',
    latest: '第 87 话',
    updateTime: '今日更新',
    desc: '一个神奇的食堂，奇葩顾客与神级厨师之间，每天上演笑到缺氧的日常。',
    exclusive: true,
  },
  {
    id: 6,
    title: '星际守望者',
    altTitle: 'Stellar Sentinel',
    cover: 'https://readdy.ai/api/search-image?query=Sci-fi%20anime%20manga%20cover%20of%20a%20mech%20warrior%20standing%20before%20a%20glowing%20nebula%2C%20amber%20and%20teal%20energy%20contrast%2C%20epic%20space%20battle%20illustration%2C%20stylized%20mecha%20design%2C%20warm%20highlights%2C%20dark%20violet%20free%20space%20backdrop%2C%20detailed%20mechanical%20linework%20artwork&width=600&height=800&seq=manga-cover-06&orientation=portrait',
    category: '科幻星际',
    status: '连载中',
    episodes: 233,
    views: '921万',
    rating: '9.4',
    latest: '第 233 话',
    updateTime: '昨日更新',
    desc: '机甲与星空交织的宏大科幻史诗，一场守护星系的壮阔征途。',
    uncensored: true,
  },
  {
    id: 7,
    title: '深渊远征',
    altTitle: 'Abyss Expedition',
    cover: 'https://readdy.ai/api/search-image?query=Adventure%20anime%20manga%20cover%20of%20an%20expedition%20party%20crossing%20a%20rugged%20mountain%20pass%20at%20sunset%2C%20warm%20orange%20sky%2C%20epic%20fantasy%20quest%20illustration%2C%20stylized%20group%20of%20adventurers%2C%20golden%20hour%20lighting%2C%20cream%20and%20amber%20palette%2C%20detailed%20landscape%20artwork&width=600&height=800&seq=manga-cover-07&orientation=portrait',
    category: '冒险热血',
    status: '连载中',
    episodes: 271,
    views: '1045万',
    rating: '9.2',
    latest: '第 271 话',
    updateTime: '今日更新',
    desc: '一支远征小队深入未知深渊，财富、秘密与生死考验交织的冒险物语。',
    preview: true,
  },
  {
    id: 8,
    title: '青春方程式',
    altTitle: 'Youth Equation',
    cover: 'https://readdy.ai/api/search-image?query=School%20anime%20manga%20cover%20of%20a%20group%20of%20high%20school%20friends%20under%20cherry%20blossoms%2C%20warm%20coral%20and%20cream%20palette%2C%20joyful%20youth%20drama%20illustration%2C%20soft%20afternoon%20light%2C%20stylized%20slice%20of%20life%2C%20clean%20bright%20background%2C%20detailed%20character%20artwork&width=600&height=800&seq=manga-cover-08&orientation=portrait',
    category: '校园青春',
    status: '已完结',
    episodes: 302,
    views: '1188万',
    rating: '9.5',
    latest: '全 302 话',
    updateTime: '已完结',
    desc: '一场关于友情、梦想与告白的青春方程式，结局温暖到让人意难平。',
  },
  {
    id: 9,
    title: '迷雾档案',
    altTitle: 'Fog Files',
    cover: 'https://readdy.ai/api/search-image?query=Crime%20mystery%20anime%20manga%20cover%20of%20a%20detective%20holding%20a%20lamp%20in%20a%20foggy%20city%20alley%2C%20warm%20amber%20and%20deep%20taupe%20tones%2C%20noir%20atmosphere%2C%20stylized%20thriller%20illustration%2C%20shadowy%20composition%2C%20detailed%20detective%20character%20artwork&width=600&height=800&seq=manga-cover-09&orientation=portrait',
    category: '悬疑推理',
    status: '连载中',
    episodes: 118,
    views: '527万',
    rating: '9.3',
    latest: '第 118 话',
    updateTime: '昨日更新',
    desc: '每一份迷雾档案背后都藏着一个惊天秘密，真相往往令人脊背发凉。',
    exclusive: true,
    uncensored: true,
  },
  {
    id: 10,
    title: '炼金术士的约定',
    altTitle: 'Alchemist Promise',
    cover: 'https://readdy.ai/api/search-image?query=Fantasy%20anime%20manga%20cover%20of%20a%20young%20alchemist%20with%20glowing%20potion%20and%20magical%20runes%2C%20gold%20amber%20and%20coral%20glow%2C%20magical%20fantasy%20illustration%2C%20stylized%20warm%20palette%2C%20enchanted%20laboratory%20backdrop%2C%20detailed%20spellbook%20and%20bottles%20artwork&width=600&height=800&seq=manga-cover-10&orientation=portrait',
    category: '奇幻异界',
    status: '连载中',
    episodes: 143,
    views: '438万',
    rating: '9.1',
    latest: '第 143 话',
    updateTime: '今日更新',
    desc: '为兑现一个约定，年轻的炼金术士踏上寻找传说贤者之石的道路。',
    preview: true,
  },
  {
    id: 11,
    title: '深夜侦探社',
    altTitle: 'Midnight Detective',
    cover: 'https://readdy.ai/api/search-image?query=Moody%20anime%20manga%20cover%20of%20a%20sleek%20detective%20agency%20interior%20at%20midnight%2C%20warm%20lamp%20light%20against%20cool%20shadows%2C%20mystery%20noir%20illustration%2C%20amber%20and%20deep%20brown%20palette%2C%20stylized%20urban%20thriller%2C%20atmospheric%20detail%20artwork&width=600&height=800&seq=manga-cover-11&orientation=portrait',
    category: '悬疑推理',
    status: '连载中',
    episodes: 96,
    views: '312万',
    rating: '9.0',
    latest: '第 96 话',
    updateTime: '昨日更新',
    desc: '只在深夜营业的侦探社，专接其它地方不敢接的离奇案件。',
  },
  {
    id: 12,
    title: '王者之路',
    altTitle: 'Path of Kings',
    cover: 'https://readdy.ai/api/search-image?query=Epic%20anime%20manga%20cover%20of%20a%20crowned%20warrior%20king%20on%20a%20throne%20with%20a%20legendary%20blade%2C%20rich%20amber%20and%20coral%20heraldry%2C%20grand%20fantasy%20royal%20illustration%2C%20stylized%20armor%20and%20crown%2C%20warm%20regal%20palette%2C%20dramatic%20lighting%2C%20detailed%20artwork&width=600&height=800&seq=manga-cover-12&orientation=portrait',
    category: '热血战斗',
    status: '已完结',
    episodes: 356,
    views: '1567万',
    rating: '9.7',
    latest: '全 356 话',
    updateTime: '已完结',
    desc: '从无名小卒到君临天下的王者，一部格局宏大的热血史诗，完结封神。',
    uncensored: true,
  },
];

export interface RankItem {
  rank: number;
  title: string;
  cover: string;
  category: string;
  latest: string;
  updateTime: string;
  heat: string;
}

export const weeklyRank: RankItem[] = [
  { rank: 1, title: '斗破九霄', cover: featured[1].cover, category: '奇幻异界', latest: '第 412 话', updateTime: '今日更新', heat: '298万' },
  { rank: 2, title: '燃魂少年', cover: featured[0].cover, category: '热血战斗', latest: '第 328 话', updateTime: '今日更新', heat: '276万' },
  { rank: 3, title: '王者之路', cover: featured[11].cover, category: '热血战斗', latest: '全 356 话', updateTime: '已完结', heat: '241万' },
  { rank: 4, title: '青春方程式', cover: featured[7].cover, category: '校园青春', latest: '全 302 话', updateTime: '已完结', heat: '219万' },
  { rank: 5, title: '深渊远征', cover: featured[6].cover, category: '冒险热血', latest: '第 271 话', updateTime: '今日更新', heat: '198万' },
  { rank: 6, title: '同桌的向日葵', cover: featured[3].cover, category: '恋爱日常', latest: '第 154 话', updateTime: '今日更新', heat: '176万' },
  { rank: 7, title: '迷雾档案', cover: featured[8].cover, category: '悬疑推理', latest: '第 118 话', updateTime: '昨日更新', heat: '152万' },
  { rank: 8, title: '星际守望者', cover: featured[5].cover, category: '科幻星际', latest: '第 233 话', updateTime: '昨日更新', heat: '134万' },
];